import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { MechanicWidget } from 'widgets/mechanic/ui';

export const MechanicPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Механика'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <MechanicWidget />;
};
